import type { Encounter, Reference } from '@medplum/fhirtypes'
import type { BundleMutationBuilder } from '#src/bundle-builder.ts'
import { invariant } from '#src/invariant.ts'
import { AppointmentEncounter } from '#src/models/encounters/appointment-encounter.ts'
import { queryTypesToString } from '#src/search.ts'

export function createAppointmentEncounterIfNoneExist(
  transaction: BundleMutationBuilder,
  encounter: AppointmentEncounter
): Reference<Encounter> {
  const appointment = encounter.appointment
  invariant(appointment, 'AppointmentEncounter requires an appointment')
  // Keyed on the patient as well as the appointment. An appointment can list
  // more than one patient, and an appointment-only match would bind this
  // create to another patient's Encounter.
  const patient = encounter.subject
  invariant(patient, 'AppointmentEncounter requires a patient')
  return transaction.create(encounter, {
    request: {
      ifNoneExist: queryTypesToString({
        ...AppointmentEncounter.searchByAppointment(appointment),
        subject: patient,
      }),
    },
  })
}
